<template>
	<div class="code-select" @click="drawer = true">
		<el-drawer :title="$t('sign.choose_area')" :visible.sync="drawer" :append-to-body="true" direction="btt"
			:before-close="handleClose" ref="drawer" size="75%">
			<div class="search-box">
				<form class="form" @submit.prevent action="javascript: void(0);">
					<el-input :placeholder="$t('sign.search')" prefix-icon="el-icon-search" v-model="searchKey"
						type="search" @input="query" />
				</form>
				<!-- <el-button type="primary" icon="el-icon-search" @click="queryChange">搜索</el-button> -->
			</div>
			<div class="area-list">
				<ul class="option-wrap" ref="optionList" v-for="group in areaListData" :key="group.group">
					<li class="option-title">{{ group.group }}</li>
					<li class="option" v-for="item in group.list" :disabled="item.code === '86'"
						:key="item.code+item.name" :value="item.code" @click="choose(item)">
						<!-- <span>{{ `${item.cnName} / ${item.name}` }}</span> -->
						<span>{{ $i18n.locale === 'en' ? item.name : item.cnName }}</span>
						<span class="fr">+{{ item.code }}</span>
					</li>
				</ul>
			</div>
		</el-drawer>
		<span class="show">+{{ areaCode }}</span>
	</div>
</template>

<script>
	import {
		debounce
	} from '@/commons/tools.js'
	export default {
		name: 'CodeSelect',
		model: {
			prop: 'areaCode',
			event: 'code-change'
		},
		props: {
			areaList: {
				default () {
					return []
				},
				type: Array
			},
			// areaCode: { type: [String, Number], default: '852' }
		},
		data() {
			return {
				areaCode: '852',
				drawer: false,
				searchKey: '',
				areaListData: [],
				deSearch: null
			}
		},
		watch: {
			areaList(newVal) {
				if (newVal) {
					this.areaListData = this.areaList
				}
			},
			searchKey(newVal, oldVal) {
				if (!newVal) {
					this.areaListData = this.areaList
				}
			}
		},
		mounted() {
			this.initDebounceSearch()
			document.addEventListener('keyup', (event) => {
				if (event.keyCode == '13') {
					this.queryChange()
				}
			})
		},
		methods: {
			//   初始化防抖搜索函数
			initDebounceSearch() {
				this.deSearch = debounce(() => {
					this.queryChange()
				}, 500, false)
			},
			query() {
				this.deSearch()
			},
			handleClose(done) {
				done()
			},
			escapeRegexpString(value = '') {
				String(value).replace(/[|\\{}()[\]^$+*?.]/g, '\\$&')
			},
			queryChange() {
				const query = this.searchKey
				if (!query) {
					return
				}
				const reg = new RegExp(query, 'i')
				this.areaListData = []
				let result = {
					group: '',
					list: []
				}
				this.areaList.forEach((group, index) => {
					group.list.forEach((item, ind) => {
						if (reg.test(item.cnName) || reg.test(item.name) || reg.test(item.code)) {
							result.list.push(item)
						}
					})
				})
				this.areaListData = [result]
				// this.visible = new RegExp(this.escapeRegexpString(query), 'i').test(`${item.cnName}/${item.name}`)
			},
			selectChange() {
				this.$emit('code-change', this.areaCode)
			},
			choose(item) {
				this.areaCode = item.code
				this.$emit('code-change', item.code)
				this.$refs.drawer.closeDrawer()
			}
		}
	}
</script>

<style lang="less">
	.code-select {
		position: relative;
		width: 135px;
		height: 100px;

		.show {
			line-height: 100px;
			text-align: center;
			display: inline-block;
			width: 135px;
			font-size: 32px;
		}
	}

	.el-drawer {
		border-radius: 8px 8px 0 0;
	}

	.el-drawer__header {
		height: 100px;
		font-size: 32px;
		text-align: center;
		font-weight: 500;

		span {
			color: #191929;
			font-family: PingFang SC, PingFang SC-Medium;
		}

		button {
			font-size: 40px;
			position: absolute;
			right: 30px;
		}
	}

	.el-drawer__body {
		.search-box {
			padding: 16px 30px;
			position: absolute;
			height: 120px;
			background: #ffffff;
			top: 100px;

			form {
				display: inline-block;
			}
		}

		.el-input {
			width: 690px;
			height: 88px;

			// padding: 0 30px;
			.el-input__prefix {
				left: 30px;
				font-size: 28px;

				.el-input__icon {
					line-height: 88px;
					color: #95959C;
				}
			}

			input {
				height: 88px;
				border-radius: 44px;
				font-size: 28px;
				color: #33333A;
				padding: 0 30px 0 60px;
				background: #F8F9FB;
				border-color: #F8F9FB;

				&::-webkit-input-placeholder {
					color: #95959C;
				}

				&:focus {
					border-color: #F8F9FB;
				}
			}
		}

		.el-button {
			background: #FFA41F;
			border-color: #FFA41F;
			height: 60px;
			border-radius: 30px;
			font-size: 30px;
		}

		.area-list {
			padding: 120px 0px 40px;

			ul {}

			.option-title {
				font-size: 28px;
				height: 60px;
				line-height: 60px;
				background-color: #F8F9FB;
				padding: 0 30px;
			}

			li.option {
				height: 100px;
				line-height: 100px;
				font-size: 32px;
				color: #33333A;
				border-bottom: 1px solid #EBECF0;
				padding: 0 30px;
				font-family: PingFang SC, PingFang SC-Medium;
				font-weight: 400;
				align-items: center;
				justify-content: space-between;
				display: flex;

				.fr {
					float: right;
					font-family: DINPro, DINPro-Medium;
					font-weight: 500;
				}
			}
		}
	}
</style>